import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import half_star from 'half_star.svg';
import star_empty from 'star_empty.svg';

const getStar = (rating, starIndex, secondaryColor) => {
  let activeClassname = 'active';
  if (secondaryColor) {
    activeClassname = 'active-secondary';
  }

  if (Math.round(rating) !== rating && Math.round(rating) === starIndex)
    return <ReactSVG key={starIndex} src={half_star} className="star half" />;

  if (rating >= starIndex)
    return (
      <ReactSVG
        key={starIndex}
        src={star_empty}
        className={`star ${activeClassname} full `}
      />
    );

  return <ReactSVG key={starIndex} src={star_empty} className="star" />;
};

const stars = [1, 2, 3, 4, 5];

export default function Ratings({
  rating,
  hideReviewCount,
  rating_count,
  secondaryColor = false,
}) {
  return (
    <div className="ratings-container">
      {stars.map((_, ind) =>
        getStar(parseFloat(rating), ind + 1, secondaryColor)
      )}
      {!hideReviewCount && (
        <p className="secondary-text review-count">({rating_count || 0})</p>
      )}
    </div>
  );
}

Ratings.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rating_count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hideReviewCount: PropTypes.bool,
  secondaryColor: PropTypes.bool,
};
